// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { linkCancel16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-link-cancel': IconLinkCancel;
    }
}

/**
 * The icon component for the 'linkCancel' icon
 */
export class IconLinkCancel extends IconSvg {
    public constructor() {
        super(linkCancel16X16);
    }
}

registerIconSvg('icon-link-cancel', IconLinkCancel);
export const iconLinkCancelTag = 'nimble-icon-link-cancel';
